import { motion } from 'framer-motion'
import { Helmet } from 'react-helmet-async'
import { useTranslation } from 'react-i18next'
import StatsCards from './components/StatsCards'
import Notifications from './components/Notifications'
import AssetFlow from './components/AssetFlow'
import AssetFlowChart from './components/AssetFlowChart'

const DashboardPage = () => {
  const { t } = useTranslation(['dashboard', 'common'])

  return (
    <>
      <Helmet>
        <title>{t('dashboard:pageTitle')}</title>
      </Helmet>

      <div className="p-3 sm:p-6 space-y-4 sm:space-y-6 overflow-x-hidden max-w-full">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="flex flex-col space-y-3 sm:space-y-0 sm:flex-row sm:items-center sm:justify-between"
        >
          <div>
            <h1 className="text-xl sm:text-2xl font-bold text-white">{t('dashboard:title')}</h1>
            <p className="text-dark-400 mt-1 text-sm sm:text-base">
              {t('dashboard:welcome')}
            </p>
          </div>

          <div className="flex items-center justify-center sm:justify-start space-x-3">
            <div className="flex items-center space-x-2 text-sm text-dark-300">
              <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></div>
              <span>{t('dashboard:realtimeUpdate')}</span>
            </div>
          </div>
        </motion.div>

        {/* Stats Cards - Hidden on mobile */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.1 }}
          className="hidden sm:block"
        >
          <StatsCards />
        </motion.div>

        {/* Main Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 sm:gap-6 overflow-x-hidden">
          {/* Left Column - 2/3 width on desktop, full width on mobile */}
          <div className="lg:col-span-2 space-y-4 sm:space-y-6 min-w-0">
            {/* Asset Flow */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2 }}
            >
              <AssetFlow />
            </motion.div>

            {/* Asset Flow Chart */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.3 }}
            >
              <AssetFlowChart />
            </motion.div>
          </div>

          {/* Right Column - 1/3 width on desktop, full width on mobile */}
          <div className="space-y-4 sm:space-y-6 min-w-0">
            {/* Notifications */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.4 }}
            >
              <Notifications />
            </motion.div>
          </div>
        </div>
      </div>
    </>
  )
}

export default DashboardPage
